import { Navigate, useLocation } from "react-router-dom";
import { Layout } from "../layout/Layout";
import { UserCard } from "../components/UserCard";
import { UserDetails } from "../components/UserDetails";
import { useAuthSessionContext } from "../components/routing/auth-session-store";
import { useUserProfileData } from "../hooks/useUserProfileData";
import { CouponCarousel } from "../components/CouponCarousel";
import { useDiscountsByUser } from "../hooks/";

export const UserProfile = () => {
	const location = useLocation();
	const { session } = useAuthSessionContext();
	const { profile, addresses, orders, isLoading, error, refreshAddresses } =
		useUserProfileData(session);
	const locationState = (location.state as { initialTab?: string } | null) ?? null;
	const initialTab = locationState?.initialTab;

	// <-- Obtenemos los cupones del usuario logueado
	const userId = session?.user?.id || 0;
	const { data: couponsRaw } = useDiscountsByUser(userId);
	const coupons = Array.isArray(couponsRaw) ? couponsRaw : [];

	if (!session?.user?.id) {
		return <Navigate to='/login' replace />;
	}

	if (session.user.type_user === "Proveedor") {
		return <Navigate to='/service/profile' replace />;
	}

	return (
		<Layout>
			{isLoading ? (
				<div className='px-4 sm:px-8 mt-6 sm:mt-8'>
					<div className='bg-white rounded-2xl border border-gray-100 shadow-sm p-6 text-gray-500'>
						Cargando perfil...
					</div>
				</div>
			) : error ? (
				<div className='px-4 sm:px-8 mt-6 sm:mt-8'>
					<div className='bg-rose-50 rounded-2xl border border-rose-200 shadow-sm p-6 text-rose-700'>
						{error}
					</div>
				</div>
			) : (
				<>
					<UserCard
						profile={
							profile
								? {
										name: profile.name,
										email: profile.email,
										since: profile.since,
										avatar: profile.avatar,
									}
								: undefined
						}
					/>
					<CouponCarousel coupons={coupons} />
					<UserDetails
						initialTab={initialTab}
						profile={
							profile
								? {
										id: session.user.id,
										name: profile.name,
										email: profile.email,
										phone: profile.phone,
										municipality: profile.city,
										address: profile.address,
										clients: profile.clients,
										dateOfBirth: profile.dateOfBirth,
										gender: profile.gender,
									}
								: undefined
						}
						orders={orders}
						addresses={addresses}
						onAddressesChange={() => {
							void refreshAddresses();
						}}
					/>
				</>
			)}
		</Layout>
	);
};

